export default {"src":"/_next/static/media/document-types.e3a7cf23.svg","height":86,"width":86,"blurWidth":0,"blurHeight":0};